<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="业务类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag :disabled="isEdit" type="list"
                                 v-decorator="['businessType', validatorRules.businessType]" :trigger-change="true"
                                 :options="businessTypeDict" placeholder="请选择业务类型" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="投保人" :labelCol="labelCol" :wrapperCol="wrapperCol" :help="insureTip">
              <a-dropdown  :trigger="['click']" placement="bottomLeft">
                <a-input-search allowClear v-decorator="['insure', validatorRules.insure]" placeholder="请输入投保人"
                                @input="insureInput" @search="insureSearch"
                                @focus="insureInputFocus" @blur="insureBlur">
                </a-input-search>
                <a-menu v-if="insureDropDownList.length > 0" slot="overlay">
                  <a-menu-item v-for="(item,index) in insureDropDownList" :key="item">
                    <span @click="insureChange(item)">{{item}}</span>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="项目组" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['project', validatorRules.project]"
                                 :trigger-change="true" dictCode="bms_project" placeholder="请选择项目组"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="立项名称" :labelCol="labelCol" :wrapperCol="wrapperCol" :help="projectInfoId">
              <j-search-select-tag placeholder="立项名称"
                                   v-decorator="['projectInfoId', validatorRules.projectInfoId]"
                                   :trigger-change="true" dict="proj_project,name,id" :async="true" disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="二级单位" :labelCol="labelCol" :wrapperCol="wrapperCol" :help="insureParentOrg">
              <j-search-select-tag placeholder="二级单位"
                                   v-decorator="['insureParentOrg', validatorRules.insureParentOrg]"
                                   :trigger-change="true" dict="biz_customer,name,id" :async="true" disabled>
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="被保险人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['insured', validatorRules.insured]" placeholder="请输入被保险人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="被保险人联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['insuredTel', validatorRules.insuredTel]" placeholder="请输入被保险人联系方式"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="被保险人通讯地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['insuredAddr', validatorRules.insuredAddr]" placeholder="请输入被保险人通讯地址"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保险公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-decorator="['insurerNumber', validatorRules.insurerNumber]"
                :trigger-change="true"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="标的类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['productOrLife', validatorRules.productOrLife]"
                                 :trigger-change="true" dictCode="product_or_life" placeholder="请选择标的类型" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="标的名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['subjectName', validatorRules.subjectName]" placeholder="请输入标的名称"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="险种名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag v-decorator="['insuranceName', validatorRules.insuranceName]" :trigger-change="true"
                                   dict="biz_insurance_with_type,insurance_name,insurance_name"
                                   placeholder="请输入险种全称"></j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="险种类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag ref="insuranceType" type="list"
                                 v-decorator="['insuranceType', validatorRules.insuranceType]" :trigger-change="true"
                                 dictCode="bms_insurance_type" placeholder="险种类型" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="车牌号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['car', validatorRules.car]" placeholder="请输入车牌号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保险起期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择保险起期" v-decorator="['insuranceStart', validatorRules.insuranceStart]"
                      :trigger-change="true" style="width: 100%" @change="onInsuranceStartChange"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保险讫期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择保险讫期" v-decorator="['insuranceEnd', validatorRules.insuranceEnd]"
                      :trigger-change="true" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="核算日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择核算日期" v-decorator="['accountDate', validatorRules.accountDate]"
                      :trigger-change="true" style="width: 100%" @change="onAccountDateChange"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保单状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- policyStatus 不是库表字段(@TableField(exist=false))，由列表接口按保险止期实时算成
                   "有效"/"失效"，本身就是中文字面量、不需要字典翻译。原先用 j-dict-select-tag 引用
                   bms_policyStatus，而该字典在 sys_dict 中并不存在：下拉永远为空，每次打开表单还白发
                   一次 HTTP。改回只读输入框，显示效果不变。 -->
              <a-input v-decorator="['policyStatus']" disabled placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['policy', validatorRules.policy]" placeholder="请输入保单号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="批单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['endNum', validatorRules.endNum]" placeholder="请输入批单号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="缴费类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['lifeInsurancePayType',{}]" :trigger-change="true"
                                 dictCode="bms_life_insurance_pay_type" placeholder="请输入缴费类型" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保费(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator.number="['premium', validatorRules.premium]" :formatter="moneyFormatter" :parser="moneyParser"
                              placeholder="请输入保费" style="width: 100%" @change="calNoRate"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保额(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['insuredAmount', validatorRules.insuredAmount]"
                              :formatter="moneyFormatter" :parser="moneyParser"
                              placeholder="请输入保额" style="width: 100%;" @change="calRate"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="费率(‰)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator.number="['rate', validatorRules.rate]" placeholder="请输入费率(单位‰)"
                              style="width: 100%" @change="calRate"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="去税保费(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator.number="['cleanPremium', validatorRules.cleanPremium]"
                              :formatter="moneyFormatter" :parser="moneyParser" placeholder="请输入去税保费" style="width: 100%"
                              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="发票税率(%)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['taxRate', validatorRules.taxRate]" placeholder="请输入发票税率"
                              style="width: 100%" @change="recalcInvoiceClean"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="佣金是否含税" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['includeTax', validatorRules.includeTax]"
                                 :trigger-change="true" dictCode="bms_include_tax"
                                 placeholder="保司结算的佣金是否含税" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="佣金比例(%)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :min="0" :max="100" v-decorator.number="['brokerageRatio', validatorRules.brokerageRatio]"
                              @change="brokerageRatioChange"
                              placeholder="请输入佣金比例" style="width: 100%"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="佣金(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['brokerageTotal', validatorRules.brokerageTotal]"
                              :formatter="moneyFormatter" :parser="moneyParser" placeholder="请输入总佣金"
                              style="width: 100%" @change="recalcInvoiceClean">
              </a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="总佣金(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :value="form.getFieldValue('brokerageTotal')"
                              :formatter="moneyFormatter" placeholder="总佣金"
                              disabled
                              style="width: 100%">
              </a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="净佣金(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['invoiceCleanAmount', {}]"
                              :formatter="moneyFormatter" placeholder="自动计算（总佣金÷(1+税率%)）"
                              disabled
                              style="width: 100%">
              </a-input-number>
            </a-form-item>
          </a-col>
<!--          <a-col :span="24" style="display: none;">
            <a-form-item label="开票金额(元)" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input-number v-decorator="['invoiceAmount']" :formatter="moneyFormatter"
                              placeholder="请输入开票金额" style="width: 100%"
                              ></a-input-number>
            </a-form-item>
          </a-col>-->
<!--          <a-col :span="24">
            <a-form-item label="票外金额(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['outsideInvoiceAmount', validatorRules.outsideInvoiceAmount]"
                              :formatter="moneyFormatter" placeholder="请输入票外金额" style="width: 100%"></a-input-number>
            </a-form-item>
          </a-col>--><!--V12-->


          <a-col :span="24">
            <a-form-item label="开票单位" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                v-decorator="[ 'invoiceUnit', validatorRules.invoiceUnit]"
                placeholder="请选择开票单位"
                :getPopupContainer="(target) => target.parentNode">
                <a-select-option v-for="(item) in invoiceUnits" :value="item.orgCode" :key="item.orgCode">{{ item.departName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="期数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['phase',validatorRules.phase]" placeholder="请输入期数"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="区域" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['zone', validatorRules.zone]" placeholder="请输入区域"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="所属渠道" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['channel']" :trigger-change="true" disabled
                                 dictCode="bms_channel" placeholder="直属渠道" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="互联网标识" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['internet']" :trigger-change="true" disabled
                                 dictCode="bms_internet" placeholder="传统业务" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="涉农标识" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['agFlag']" :trigger-change="true" disabled
                                 dictCode="bms_agFlag" placeholder="非农业险" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-tooltip>
                <template slot="title">
                  1. 文件名只能包含字母、数字、下划线、连字符、点号。不能包含空格或其他特殊字符<br>
                  2. 文件名不能以点号(.)或者下划线(_)开头或结尾<br>
                  3. 文件名不能有两个以上的点号(.)<br>
                  4. 常见的特殊字符有：标点符号、数学符号、货币符号、空格、引号等等
                </template>
                <j-upload v-decorator="['file']" :trigger-change="true" bizPath="achievement" :disabled="formDisabled"
                          @change="handleFileChange" :beforeUpload="beforeUpload">
                </j-upload>
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item>
              <div style="border-bottom: 1px solid #e8e8e8; margin-bottom: 10px;"></div>
              <a-button type="link" @click="autoFillForm">自动填充测试数据</a-button>
              <a-button style="float:right;margin-right:10px;" @click="cancel">取消</a-button>
              <a-button style="float:right;margin-right:10px;" @click="saveAndCommit">保存并提交</a-button>
              <a-button type="primary" style="float:right;margin-right:10px;" @click="save">保存</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction, postAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue, moneyFormatter, moneyParser, toDecimal } from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JDate from '@/components/jeecg/JDate'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import JTreeSelect from '@/components/jeecg/JTreeSelect'
import JUpload from '@/components/jeecg/JUpload'
import { NewBusinessTypeDictOptions, AllBusinessTypeDictOptions } from '../../enums/businessTypeDictOptions'
import Vue from 'vue'
import 'ant-design-vue/dist/antd.css'
import 'ant-design-vue/dist/antd.js'
export default {
  name: 'BizBusinessinfoForm',
  components: {
    JFormContainer,
    JDate,
    JDictSelectTag,
    JSearchSelectTag,
    JTreeSelect,
    JUpload
  },
  props: {
    //表单data
    formData: {
      type: Object,
      default: () => {
      },
      required: false
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function() {
    return {
      insureParentOrg: '如果二级单位不一致，请联系运营部更改',
      projectInfoId: '', // 立项名称，项目信息id
      insureValue: '',
      insureDropDownList: new Array(),
      timer: null,
      // 投保人失焦触发带出项目组用：防抖定时器 + 上次已查过的投保人，避免重复请求和竞态
      insureBlurTimer: null,
      // 投保人查不到立项时的常驻提示，显示在投保人输入框下面，不用弹窗（弹窗一闪而过容易看不到）
      insureTip: '',
      lastInsureQueried: '',
      form: this.$form.createForm(this),
      model: {},
      invoiceUnits: [],
      isEdit: false, // 是否编辑，而非新增
      businessTypeOptions: [{ value: '0', text: '运维' },{ value: '1', text: '直拓' }, { value: '4', text: '合作' }, { value: '5', text: '其他' }],
      newBusinessTypeDictOptions: [],
      allBusinessTypeDictOptions: [],
      businessTypeDict: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {
        businessType: {
          rules: [
            { required: true, message: '请选择业务类型!' },
            { validator: this.checkBusinessTypeShortName }
          ]
        },
        /*businessPerformanceType: {
          rules: [
            { required: true, message: '请选择业绩类型!' }
          ]
        },*/
        productOrLife: {
          rules: [
            { required: true, message: '请选择标的类型!' }
          ]
        },
        subjectName: {
          rules: [
            /*{ required: true, message: '请输入标的名称!' }*/
          ]
        },
        dep: {
          rules: [
            { required: true, message: '请选择部门!' }
          ]
        },
        /*
                  broker: {
                    rules: [
                      { required: true, message: '请输入经纪人!' },
                      { max: 20, message: '经纪人长度不能超过20' }
                    ]
                  },
                  */
        insure: {
          rules: [
            { required: true, message: '请输入投保人!' },
            { max: 255, message: '投保人长度不能超过255个字符' },
            { whitespace: true, message: '不能为空格' }
            // { validator: this.checkBusinessType }
          ]
        },
        project: {
          rules: [
            { required: true, message: '请选择项目组' }
          ]
        },
        insured: {
          rules: [
            { required: true, message: '请输入被保险人!' },
            { max: 255, message: '被保险人长度不能超过255个字符' },
            { whitespace: true, message: '不能为空格' }
          ]
        },
        insuredTel: {
          rules: [
            { required: false, message: '请输入被保险人联系方式!' },
            { max: 255, message: '被保险人联系方式长度不能超过255个字符' }
          ]
        },
        insuredAddr: {
          rules: [
            { required: false, message: '请输入被保险人通讯地址!' },
            { max: 255, message: '被保险人通讯地址长度不能超过255个字符' }
          ]
        },
        insurerNumber: {
          rules: [
            { required: true, message: '请选择保险公司!' },
            { validator: this.checkInsurerAgreement }
          ]
        },
        insuranceType: {
          rules: [
            { required: true, message: '请选择险种类型!' }
          ]
        },
        endNum: {
          rules: [
            { message: '请输入批单号' }
          ]
        },
        insuranceName: {
          rules: [
            { required: true, message: '请输入险种名称!' },
            { max: 50, message: '险种名称长度不能超过50' },
            { whitespace: true, message: '不能为空格' },
            { validator: this.checkInsuranceType }
          ]
        },
        car: {
          rules: [
            //{ required: true, message: '请输入车牌号!'},
            { max: 10, message: '车牌号长度不能超过10' },
            { whitespace: true, message: '不能为空格' }
          ]
        },
        insuranceStart: {
          rules: [
            { required: true, message: '请输入保险起期!' }
          ]
        },
        insuranceEnd: {
          rules: [
            { required: true, message: '请输入保险讫期!' }
          ]
        },
        accountDate: {
          rules: [
            { required: true, message: '请输入核算日期!' }
          ]
        },
        policy: {
          rules: [
            { required: true, message: '请输入保单号!' },
            { max: 30, message: '保单号长度不能超过30' },
            { whitespace: true, message: '不能为空格' }
          ]
        },
        insuredAmount: {
          rules: [
            { required: true, message: '请输入保额!' }
            // { type: 'number', message: '只能输入数值' },
          ]
        },
        rate: {
          rules: [
            { required: true, type: 'number', trigger: 'blur', message: '请输入费率(单位‰)!' }
            // { type: 'number', message: '只能输入数值' },
          ]
        },
        premium: {
          rules: [
            { required: true, type: 'number', trigger: 'blur', message: '请输入保费!' }
            // { type: 'number', message: '只能输入数值' },
          ]
        },
        cleanPremium: {
          rules: [
            { required: true, type: 'number', trigger: 'blur', message: '请输入去税保费!' }
            // { type: 'number', message: '只能输入数值' },
          ]
        },
        includeTax: {
          rules: [
            { required: true, message: '请选择是否含税!' }
          ]
        },
        brokerageRatio: {
          rules: [
            { required: true, type: 'number', trigger: 'blur', message: '请输入佣金比例!' }
            // { type: 'number', message: '只能输入数值' },
          ]
        },
        brokerageTotal: {
          rules: [
            { required: true, type: 'number', trigger: 'blur', message: '请输入总佣金!' }
            // { type: 'number', message: '只能输入数值' },
          ]
        },
        /*invoiceRatio: {
          rules: [
            { required: true, type: 'number', trigger: 'blur', message: '请输入开票比例!' }
          ]
        },*/
/*        invoiceAmount: {
          rules: [
            { required: true, type: 'number', trigger: 'blur', message: '请输入开票金额!' }
            // { type: 'number', message: '只能输入数值' },
          ]
        },*/
/*        outsideInvoiceAmount: {
          rules: [
            { type: 'number', trigger: 'blur', message: '开票金额只能是数字!' }
          ]
        },*/
        taxRate: {
          rules: [
            { required: true, type: 'number', trigger: 'blur', message: '发票税率只能是数字!' }
          ]
        },
        invoiceUnit: {
          rules: [
            { required: true, trigger: 'blur', message: '请选择开票单位!' }
          ]
        },
        phase: {
          rules: [
            { required: true, message: '请输入期数!' },
            { pattern: /^[1-9]\/[1-9]$/, message: '期数格式为1/3,表示第1期/共3期' }
          ]
        },
        zone: {
          rules: [
            { max: 30, message: '区域长度超过30个字符' },
            { whitespace: true, message: '不能为空格' }
          ]
        },
        agFlag: {
          rules: [
            { max: 30, message: '涉农标识长度超过30个字符' },
            { whitespace: true, message: '不能为空格' }
          ]
        },
        channel: {
          rules: [
            { required: true, message: '请选择所属渠道' }
          ]
        },
        projectInfoId: {
          rules: [
            { message: '如果是运维渠道，并且被保人名称与立项名称不一致，请填写' }
          ]
        },
        internet: {
          rules: [
            { required: true, message: '请选择互联网标识' }
          ]
        },
        policyStatus: {
          rules: []
        }
      },
      url: {
        add: '/bms/bizBusinessinfo/add',
        edit: '/bms/bizBusinessinfo/edit',
        queryById: '/bms/bizBusinessinfo/queryById',
        checkProjectShortName: '/bms/bizBusinessinfoProject/getShortName',
        checkBusinessTypeShortName: '/bms/bizBusinessinfoBusinessType/getShortName',
        checkInsurerAgreement: '/biz/bizAgreementinfo/judgeAgreementByCode',
        checkInsuranceType: '/biz/insuranceWithType/getInsuranceTypeByName',
        getInvoiceUnit: '/sys/sysDepart/getInvoiceUnitByUser',
        upload: "/oss/file/upload",
        updateFilePathImmediate: '/bms/bizBusinessinfo/updateFilePathImmediate',
        getInsureParentOrg: '/biz/customer/getParentOrg'
      }
    }
  },
  computed: {
    uploadAction(filePath) {
      return window._CONFIG['domianURL'] + this.url.upload + filePath;
    },
    formDisabled() {
      return this.disabled
    },
    showFlowSubmitButton() {
      return false
    }
  },
  created() {
    this.initInvoiceUnit()
    this.newBusinessTypeDictOptions = NewBusinessTypeDictOptions
    this.allBusinessTypeDictOptions = AllBusinessTypeDictOptions
  },
  methods: {
    onInsuranceStartChange(val) {
      const current = this.form.getFieldValue('accountDate')
      if (!current || current === '') {
        this.form.setFieldsValue({ accountDate: val })
      }
    },
    onAccountDateChange() {
      // 占位以触发手动修改标记，无需逻辑
    },
    insureChange(item){
      this.insureValue =  item;
      this.insureDropDownList = [];
      this.form.setFieldsValue({insure: item});
      // 选中下拉项时 blur 已经先触发过，取消它那次用半截名字发起的查询
      clearTimeout(this.insureBlurTimer);

      // 直接调用 blur 事件的处理方法
      // 创建一个模拟的事件对象
      const mockEvent = { target: { value: item } };
      this.getInsureParentOrg(mockEvent);
    },
    insureInputFocus(){
      this.insureDropDownList = [];
    },
    // 投保人失焦即重新带出项目组、立项名称、二级单位。
    // 手输投保人且匹配到多个客户时不会走 insureChange，只有这里能保证改了投保人项目组跟着变。
    // 点下拉项时浏览器会先触发 blur、后触发 click，所以延迟一下等 insureChange 填完整名称。
    insureBlur(e){
      const typed = e && e.target ? e.target.value : '';
      clearTimeout(this.insureBlurTimer);
      this.insureBlurTimer = setTimeout(() => {
        const value = this.form.getFieldValue('insure') || typed;
        this.getInsureParentOrg({ target: { value: value } });
      }, 300);
    },
    insureInput(e){
      clearTimeout(this.timer);
      this.timer = setTimeout(()=>{
        this.insureSearch(e.target.value)
      }, 1000);
    },
    insureSearch(v){
      this.insureDropDownList = [];
      if(v.length>1){
        // 关键字过滤与限量交给后端，避免每次输入都全量拉取客户档案
        getAction('/sys/dict/loadDict/biz_customer,name,name', {keyword: v, pageSize: 20}).then((res) => {
          if (res.success) {
            this.insureDropDownList = res.result.map((item) => item['text']);
            // 当只有一个匹配项时，自动填充到输入框
            if (this.insureDropDownList.length === 1) {
              this.insureChange(this.insureDropDownList[0]);
            }
          }
        })
      }
    },
    moneyFormatter,
    moneyParser,
    initInvoiceUnit() {
      this.invoiceUnits = []
      //根据当前登录用户获取能选择的开票单位
      getAction(this.url.getInvoiceUnit, {}).then((res) => {
        if (res.success) {
          this.invoiceUnits = res.result
        }
      })
    },
    add(sourcePage) {
      this.edit({}, sourcePage)
    },
    copyAdd(record) {
      //复制record
      let newRecord = JSON.parse(JSON.stringify(record))
      // 清空系统字段
      newRecord.id = null
      newRecord.createBy = null
      newRecord.createTime = null
      newRecord.updateBy = null
      newRecord.updateTime = null
      newRecord.invoiceNumber = null
      newRecord.invoiceTime = null
      newRecord.invoiceAmount = null  // 复制新增不复制开票金额
      newRecord.file = null  // 把文件置空，单据间不能共用文件，防止删除时存在其他引用
      newRecord.status = '0'
      newRecord.insideOrOutside = '0'
      newRecord.confirmTime = null

      // 将保险起讫期增加一年
      if (newRecord.insuranceStart) {
        const startDate = new Date(newRecord.insuranceStart)
        startDate.setFullYear(startDate.getFullYear() + 1)
        newRecord.insuranceStart = startDate.toISOString().split('T')[0]
      }
      if (newRecord.insuranceEnd) {
        const endDate = new Date(newRecord.insuranceEnd)
        endDate.setFullYear(endDate.getFullYear() + 1)
        newRecord.insuranceEnd = endDate.toISOString().split('T')[0]
      }

      this.edit(newRecord)
    },
    edit(record, sourcePage) {
      if (record.id != null) {
        this.isEdit = true
      } else {
        this.isEdit = false
      }
      this.setBusinessTypeDictOptions()
      this.form.resetFields()
      // 组件实例会复用，重置投保人查询标记和提示，否则换一条记录可能不触发带出、或残留上一条的提示
      this.lastInsureQueried = ''
      this.insureTip = ''
      clearTimeout(this.insureBlurTimer)
      if (record.channel == null || '' == record.channel) {
        record.channel = '0'
      }
      if (record.agFlag == null || '' == record.agFlag) {
        record.agFlag = '0'
      }
      if (record.insideOrOutside == null || '' == record.insideOrOutside) {
        record.insideOrOutside = '0'
      }
      // record.invoiceAmount = record.brokerageTotal;
      record.insideOrOutside = sourcePage
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'businessType', 'project','projectInfoId','broker',
          'insure','insured', 'insurerNumber', 'productOrLife', 'insuranceType', 'insuranceName', 'car', 'insuranceStart',
          'insuranceEnd', 'accountDate', 'policy', 'insuredAmount', 'rate', 'premium', 'cleanPremium', 'includeTax', 'brokerageRatio',
          'brokerageTotal',  'taxRate', 'phase', 'zone', 'file', 'invoiceUnit','invoiceCleanAmount',
          'lifeInsurancePayType', 'channel', 'internet', 'policyStatus', 'subjectName', 'insuredTel', 'insuredAddr',
          'agFlag', 'endNum', 'cleanBrokerage','insideOrOutside','insureParentOrg','insurer'))
      })
    },
    setBusinessTypeDictOptions() {
      if (this.isEdit) { //非新增，不允许编辑业务类型，业务类型设置为全部业务类型
        this.businessTypeDict = this.allBusinessTypeDictOptions
      } else {// 新增时，只能选择新业务类型
        this.businessTypeDict = this.newBusinessTypeDictOptions
      }
    },

    submitForm(isCommit) {

      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }

          let formData = Object.assign(this.model, values)
          //去除输入的两边空格
          this.trimFormData(formData)

          // 计算发票净佣金和税额（与导入逻辑一致）
          formData.invoiceCleanAmount = toDecimal(formData.brokerageTotal / (1 + formData.taxRate / 100))
          formData.taxAmount = formData.brokerageTotal - formData.invoiceCleanAmount
          // formData.invoiceAmount = formData.brokerageTotal
          formData.insideOrOutside = '0'

          // alert(invoiceCleanAmount);
          // 设置保存时是否提交
          if(isCommit){
            formData.commitFlag = true
          } else {
            formData.commitFlag = false
          }

          httpAction(httpurl, formData, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message)
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
          })
        }

      })
    },
    trimFormData(formData) {
      formData.insure = formData.insure ? formData.insure.trim() : ''
      formData.insured = formData.insured ? formData.insured.trim() : ''
      formData.insuranceName = formData.insuranceName ? formData.insuranceName.trim() : ''
      formData.car = formData.car ? formData.car.trim() : ''
      formData.policy = formData.policy ? formData.policy.trim() : ''
      formData.zone = formData.zone ? formData.zone.trim() : ''
    },

    // 校验业务类型简写是否存在
    checkBusinessTypeShortName(rule, value, callback) {
      getAction(this.url.checkBusinessTypeShortName, { typeIndex: value }).then((res) => {
        if (res.success) {
          if (res.result != null && res.result != '') {
            callback()
          } else {
            callback('没有配置业务类型简写，请到【业务类型简写配置】功能中设置。')
          }
        } else {
          callback('没有配置业务类型简写，请到【业务类型简写配置】功能中设置。')
        }
      })
    },

    // 校验业务类型是否填写
    // checkBusinessType(rule, value, callback) {
    // },

    // 校验项目缩写是否存在
    checkProjectShortName(rule, value, callback) {
      getAction(this.url.checkProjectShortName, { projectIndex: value }).then((res) => {
        if (res.success) {
          if (res.result != null && res.result != '') {
            callback()
          } else {
            callback('没有配置项目简写，请到【项目简写配置】功能中设置。')
          }
        } else {
          callback('没有配置项目简写，请到【项目简写配置】功能中设置。')
        }
      })
    },
    // 检查是否与保司签订协议, value:保司code
    checkInsurerAgreement(rule, value, callback) {
      if (!value) { // 没有值
        callback()
      }
      getAction(this.url.checkInsurerAgreement, { companyCode: value }).then((res) => {
        if (res.success) {
          callback()
        } else {
          callback(res.message)
        }
      })
    },

    // 检查险种名称是否有对应的险种类型
    checkInsuranceType(rule, value, callback) {
      if (!value) { // 没有值
        callback()
      }
      this.form.setFieldsValue({ insuranceType: null }) // 先清空
      postAction(this.url.checkInsuranceType, { insuranceName: value }).then((res) => {
        if (res.success) {
          if (res.result) {
            let insuranceTypeId = res.result
            this.form.setFieldsValue({ insuranceType: insuranceTypeId })
            callback()
          } else {
            callback('此险种名称没有配置险种类型')
          }
        } else {
          callback('此险种名称没有配置险种类型')
        }
      })
    },

    async getInsureParentOrg (event) {
      const value = event.target.value; // 获取输入框的值
      if (!value) return; // 如果没有输入，则不触发校验
      if (value === this.lastInsureQueried) return; // 投保人没变，不重复查
      this.lastInsureQueried = value;

      try {
        this.form.setFieldsValue({ insureParentOrg: null });

        const res = await postAction(`${this.url.getInsureParentOrg}?customerName=${value}`);

        // 判断返回结果
        if (res.success && res.result) {
          this.insureTip = ''
          // 更新表单中的险种类型字段
          this.form.setFieldsValue({ insureParentOrg: res.result.customerId });
          //项目组
          this.form.setFieldsValue({ project: res.result.projectGroupId });
          //项目明细
          this.form.setFieldsValue({ projectInfoId: res.result.projectId });
        } else {
          // 查不到投保人对应的立项。只把原因常驻提示在投保人输入框下面，
          // 不清空项目组和立项名称 —— 合作、其他这类业务的投保人绝大多数都没有立项，
          // 清空会把用户手选的项目组反复抹掉，且后端对非运维业务本就不做匹配校验。
          this.insureTip = res.message || '未找到该投保人对应的立项，请联系运营部确认'
        }
      } catch (error) {
        // 捕获请求异常
        console.error('查找上级机构时发生错误:', error);
        this.insureTip = '查询投保人对应的立项失败，请稍后重试'
      }
    },
    // 开票金额改变,计算票外金额
/*    handleInvoiceAmountChange(val) {
      // 获取总金额
      let brokerageTotal = this.form.getFieldValue('brokerageTotal')
      if (isNaN(brokerageTotal) || isNaN(val)) {
        return
      }
      let outsideInvoiceAmount = toDecimal(brokerageTotal - val)
      this.form.setFieldsValue({ outsideInvoiceAmount: outsideInvoiceAmount })
    },*/

    // 根据去税保费计算含税保费,入参为去税保费
/*    calHadRate(cleanPremium) {
      if (isNaN(cleanPremium)) {
        return
      }
      let premium = toDecimal(cleanPremium * 1.06)
      this.form.setFieldsValue({ premium: premium })
    },*/
    // 根据含税保费计算去税保费,入参为含税保费
    calNoRate(premium) {
      if (isNaN(premium)) {
        return
      }
      let cleanPremium = toDecimal(premium / 1.06)
      this.form.setFieldsValue({ cleanPremium: cleanPremium })
    },
    // 根据保费/保额,计算费率
    calRate(insuranceAmount) {
      let premium = this.form.getFieldValue('premium');
      if (isNaN(insuranceAmount) || isNaN(premium)) {
        return
      }
      let rate = toDecimal((premium / insuranceAmount) * 1000)
      this.form.setFieldsValue({ rate: rate })
    },

    // 总佣金或税率变化时重算净佣金（与导入逻辑一致：净佣金 = 总佣金 ÷ (1 + 税率/100)）
    recalcInvoiceClean() {
      const brokerageTotal = this.form.getFieldValue('brokerageTotal')
      const taxRate = this.form.getFieldValue('taxRate')
      if (brokerageTotal == null || isNaN(brokerageTotal)) return
      const cleanAmount = (taxRate != null && !isNaN(taxRate))
        ? toDecimal(brokerageTotal / (1 + taxRate / 100))
        : toDecimal(brokerageTotal / 1.06)
      this.form.setFieldsValue({ invoiceCleanAmount: cleanAmount })
    },

    // 佣金比例改变
    brokerageRatioChange(newVal) {
      // 保费
      let premium = this.form.getFieldValue('premium')
      // 净保费
      let cleanPremium = this.form.getFieldValue('cleanPremium')
      // 保险公司代码
      let insurerNumber = this.form.getFieldValue('insurerNumber')
      //佣金是否含税
      let includeTax = this.form.getFieldValue('includeTax')
      //发票税率
      let taxRate = this.form.getFieldValue('taxRate')
      let brokerageTotal
      let cleanAmount

      if (insurerNumber === 'TSCXJN' || includeTax === '1') { // 泰山财险济南支公司
        if (!isNaN(premium) && !isNaN(newVal)) {
          brokerageTotal = toDecimal(premium * newVal / 100)
        }
      } else {
        if (!isNaN(cleanPremium) && !isNaN(newVal)) {
          brokerageTotal = toDecimal(cleanPremium * newVal / 100)
        }
      }
      this.form.setFieldsValue({ brokerageTotal: brokerageTotal }) // 总佣金
      if(taxRate) {
        cleanAmount = toDecimal(brokerageTotal / (1+taxRate/100))
      }else {
        cleanAmount = toDecimal(brokerageTotal / 1.06)
      }
      this.form.setFieldsValue({ invoiceCleanAmount: cleanAmount }) // 净佣金
    },

    // 文件列表改变后及时更新数据库（编辑状态下）
    handleFileChange(filePath) {
      // 编辑状态下变化，存在单据id
      let id = this.model.id
      if (id) {
        postAction(this.url.updateFilePathImmediate, { id: id, filePath: filePath }).then(res => {
          if (res.success) {
          } else {
            this.$message.warn('附件更新时出现错误:' + res.message)
          }
        })
      }
    },

    //保存按钮事件
    save(e){
      this.submitForm(false)
    },
    // 保存并提交
    saveAndCommit(e){
      this.submitForm(true)
    },
    // 取消保存
    cancel(e){
      this.$emit('cancel');
    },

    beforeUpload(file) {
      const forbiddenTypes = [
        "application/x-zip-compressed",
        "application/x-rar-compressed",
        "application/x-7z-compressed",
        "application/x-tar",
        "application/gzip",
        "application/x-bzip2",
        "application/x-xz",
        "application/x-iso9660-image",
        "application/x-apple-diskimage"
      ];
      return new Promise((resolve, reject) => {
        if (forbiddenTypes.includes(file.type)) {
          this.$message.error('不允许上传压缩文件！');
          reject();
        } else {
          resolve();
        }
      });
    },

    autoFillForm() {
      const testData = {
       businessType: '5', // 运维，根据实际选项值来定
        /*         project: '某个项目值',
                projectInfoId: '对应项目ID',*/
        insure: '测试投保人',
        insured: '测试被保险人',
        insurerNumber: 'PACXJNZXZGS',
        productOrLife: '0',
        insuranceType: '0',
        insuranceName: '财产一切险',

        insuranceStart: '2025-01-01',
        insuranceEnd: '2025-12-31',
        policy: '33652001902350079580',
        insuredAmount: 10000,
        rate: 5,
        premium: 500,
        cleanPremium: 471.7,
        includeTax: '是',
        brokerageRatio: 10,
        brokerageTotal: 6499.76,
        taxRate: 20,
        invoiceUnit: 'A03',
        phase: '1/1',
        zone: '测试区域'
      };
      this.form.setFieldsValue(testData);
    }

  }
}
</script>
